module.exports = __webpack_public_path__ + "static/media/dog.c3e334e5.png";